import React from "react";
import "./TravelSection.css";

const TravelSection = () => {
  return (
    <section className="travelSection">
      {/* Left Side Illustration */}
      <div className="travelSection-left">
        <div className="travelSection-bgShape"></div>
<img
  src="/Images/transport.png"
  alt="Cab"
  className="travelSection-image"
/>
        <div className="travelSection-badge">Easy Travel</div>
      </div>

      {/* Right Side Content */}
      <div className="travelSection-right">
        <h5 className="travelSection-subtitle">Travel with Comfort</h5>
        <h2 className="travelSection-title">
          Tempo Traveller on <span>Rent in Hyderabad</span>
        </h2>

        <div className="travelSection-paragraphs">
        <p>
            <span className="dropcap">H</span>yderabad is a hub of culture,
            history, and modern experiences. Whether you are planning a{" "}
            <b>family vacation, corporate outing</b>, pilgrimage, or a weekend
            trip with friends, our Tempo Traveller rentals make your journey
            smooth, affordable, and hassle-free.
        </p>
   
        <p>
            Our vehicles come with{" "}
            <i>spacious seating, push-back seats, powerful air-conditioning,
            and clean interiors</i>, making them ideal for both short and long
            journeys. You can choose between <b>AC and Non-AC models</b>,
            depending on your comfort and budget, with options ranging from{" "}
            <b>9-seater to 20-seater Tempo Travellers</b>.
        </p>

        <p>
            Apart from city tours, we also offer Tempo Travellers for{" "}
            <b>weddings, corporate events, educational trips, outstation tours,
            and airport transfers</b>. With experienced, well-trained drivers
            and 24/7 customer support, your safety and comfort remain our top
            priority throughout the trip.
        </p>

        </div>

        {/* CTA */}
        <div className="travelSection-cta">
          {/* <button className="travelSection-btn">Book Now</button> */}
          {/* <span className="cta-note">Limited-time discounts available </span> */}
        </div>
      </div>
    </section>
  );
};

export default TravelSection;
